module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cpo"
  }, [_c('cmp-cpo-header', {
    staticClass: "cpo--header",
    attrs: {
      "content": _vm.header
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "u-reset cpo--sections"
  }, _vm._l((_vm.sections), function(section, sectionIdx) {
    return _c('li', {
      staticClass: "cpo--section"
    }, [_c('cmp-cpo-section', {
      attrs: {
        "content": section,
        "idx": sectionIdx,
        "is-first": sectionIdx === 0,
        "is-last": sectionIdx === _vm.sections.length - 1
      }
    })], 1)
  })), _vm._v(" "), (_vm.cta) ? _c('cmp-cpo-cta', {
    staticClass: "cpo--cta",
    attrs: {
      "cta": _vm.cta
    }
  }) : _vm._e(), _vm._v(" "), _c('cmp-cpo-footer', {
    staticClass: "cto--footer",
    attrs: {
      "content": _vm.footer
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-665a3f00", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-665a3f00","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/course-progress/cpo/index.vue
// module id = 553
// module chunks = 7